import * as angular from 'angular';
import * as _ from 'lodash';

import { Group, ComponentDefinition } from '../../models';
import { IGroupService } from '../../services/data/group.service';

class MultiGroupSelector implements angular.IComponentController {
    groups: Group[];
    model: string[];

    readonly disabled: boolean;
    readonly onlyChildOf: string;
    readonly onSelect: (value: { item; value }) => void;
    readonly onRemove: (value: { item: string }) => void;

    private _groupPromise: angular.IPromise<Group[]>;

    static $inject = ['groupService'];

    constructor(private _groupService: IGroupService) {
        this._groupPromise = this._groupService
            .getAll()
            .then(data => _(data).map(d => d.group).sortBy(d => d.uniqueName).value());
    }

    $onInit() {
        if (!this.model) {
            this.model = [];
        }
        this.refresh();
    }

    $onChanges(changes: angular.IOnChangesObject) {
        if (changes['onlyChildOf']) {
            this.refresh();
        }
    }

    select($item, $value) {
        if (this.onSelect) {
            this.onSelect({ item: $item, value: $value });
        }
    }
    
    remove($item: string) {
        if (this.onRemove) {
            this.onRemove({ item: $item });
        }
    }

    private refresh() {
        this._groupPromise.then(groups => this.groups = this.filter(groups));
    }
    
    private filter(all: Group[]): Group[] {
        if (this.onlyChildOf) {
            all = all.filter(g => g.parentGUID === this.onlyChildOf);
        }
        return all;
    }
}

export const wtMultiGroupSelector: ComponentDefinition = {
    componentId: 'wtMultiGroupSelector',
    controller: MultiGroupSelector,
    template: require('./multiGroupSelector.component.html'),
    controllerAs: 'vm',
    bindings: {
        model: '=',
        disabled: '<?',
        onlyChildOf: '<?',
        onRemove: '&?',
        onSelect: '&?'
    }
};